export const setLangChangeRequest = async (newLang) => {
  fetch(`/api/lang?lang=${newLang}`, {
    method: 'POST',
  })
    .then((response) => {
      if (response.status !== 200) {
        throw new Error('Could not change language.');
      }
      location.reload();
    })
    .catch((error) => {
      console.error(error);
      // TODO: handle generic errors with a modal?
    });
};
